import service from '@/middleware';


export const currentStateApi = {
  /**
   * Obtiene el reporte current-state/report-all.
   * Soporta paginación por pageSize+pageNumber (legacy) o por cursor.
   * @param {number} pageSize
   * @param {number} pageNumber
   * @param {Array} things
   * @param {string|null} cursor
   */
  async getCurrentStateAll(pageSize, pageNumber, things = [], cursor = null) {
    console.log('things in getCurrentStateAll:', things)
    console.log('getCurrentStateAll pageSize:', pageSize, ' pageNumber:', pageNumber, ' cursor:', cursor, ' thingsLength:', (things || []).length)
    let url = '/api/current-state/report-all'
    const params = []
    if (cursor) {
      params.push(`cursor=${encodeURIComponent(cursor)}`)
    }
    if (pageSize && pageSize > 0) {
      params.push(`pageSize=${pageSize}`)
    }
    if (pageNumber && pageNumber > 0 && !cursor) {
      // legacy pageNumber only used when cursor is not provided
      params.push(`pagenumber=${pageNumber}`)
    }
    if (params.length > 0) {
      url = `${url}?${params.join('&')}`
    }
    const body = { things }
    const result = await service.http.post(url, body)
    return result.data
  },
}